import React, { PureComponent } from "react";
import KBELogo from "../img/kbe-Logo-66454.png";
import { Link } from "react-router-dom";
import { Alert } from "reactstrap";
import MailRuIcon from "mdi-react/MailRuIcon";
import AppConfig from "../../../config/appconfig.json";

class ForgotPassword extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      isError: false,
      errorMsg: "",
      email: "",
      isSubmitSuccess: false
    };

    this.handleForgotPassword = this.handleForgotPassword.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
  }

  handleForgotPassword(e) {
    this.setState({ isError: false, isLoading: true });
    let isForgotPasswordFailed = false;
    fetch(
      `${AppConfig.BACK_END_URL}/APIClient/RequestPasswordReset?email=` +
        this.state.email
    )
      .then(response => {
        if (response.ok === false) {
          isForgotPasswordFailed = true;
        }
        return response.json();
      })
      .then(json => {
        if (isForgotPasswordFailed) {
          const respObj = JSON.parse(json);
          this.setState({
            isError: true,
            errorMsg: respObj.Message,
            isLoading: false
          });
        } else {
          this.setState({ isLoading: false, isSubmitSuccess: true });
        }
      })
      .catch(() => {
        this.setState({
          isError: true,
          errorMsg:
            "Something went wrong when finding your account. Please try again.",
          isLoading: false
        });
      });
    e.preventDefault();
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value
    });
  }

  render() {
    return (
      <div className="account">
        <div className="account__wrapper">
          <div className="account__card">
            <div className="account__head">
              <img src={KBELogo} alt="logo" />
              {this.state.isSubmitSuccess ? (
                <p>
                  We just emailed a reset link to {this.state.email}. Click the
                  link to reset your password.
                </p>
              ) : (
                <p>
                  Please enter the email address associated with your account,
                  and we’ll send a magic link to your inbox.
                </p>
              )}
            </div>
            {this.state.isSubmitSuccess ? (
              <div />
            ) : (
              <div>
                {this.state.isError ? (
                  <Alert color="danger">
                    <div className="alert__content">
                      <p>
                        <span className="bold-text">Error!</span>{" "}
                        {this.state.errorMsg}
                      </p>
                    </div>
                  </Alert>
                ) : (
                  <div />
                )}
                <form className="form" onSubmit={this.handleForgotPassword}>
                  <div className="form__form-group">
                    <label className="form__form-group-label">E-mail</label>
                    <div className="form__form-group-field">
                      <div className="form__form-group-icon">
                        <MailRuIcon />
                      </div>
                      <input
                        type="email"
                        name="email"
                        placeholder="example@mail.com"
                        onChange={this.handleInputChange}
                        required
                      />
                    </div>
                  </div>
                  <input
                    type="submit"
                    className="btn btn-primary account__btn"
                    value="Continue"
                    disabled={this.state.isLoading}
                  />
                </form>
              </div>
            )}
            <div className="account__have-account">
              <p>
                Still remember your account? <Link to="/">Login</Link>
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ForgotPassword;



// WEBPACK FOOTER //
// ./src/pages/account/reset_pass/ForgotPassword.js